module.exports = __webpack_public_path__ + "static/media/portfolio_template.180581e6.csv";